<template>
  <div class="slide-wraaper">
    <div class="container">
      <div class="txt-box">
        <h3 class="title">
          <strong> SW와 HW가 결합된</strong> <br />
          차별화된 솔루션을 제공합니다
        </h3>
        <p class="desc">
          지속적인 사업확장과 성장을 통해 고객에게 신뢰 받는 기업이 되도록
          노력합니다.
        </p>
<!--        <span class="scroll">scroll</span>-->
       
      </div>
      <div class="scroll-down-wrap">
          <!-- animation-4 -->
          <h4>Scroll Down</h4>
          <!-- copy from here -->
          <div class="scroll-line">
            <div class="scroll-down"></div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mainContent",

  data() {
    return {
    };
  },
};
</script>

<style></style>
